import React, { useState, useEffect } from 'react'
import { util } from './util'
import EmbPreview from './embPreview'
import axios from 'axios'
const visitorCountry = window.Shopify?.country || 'US';
const getCurrency = () => {
  const marketHandle =window.Shopify?.country || 'US';
  return marketHandle == 'CA' ? 'CAD' : 'USD';
};
// Line items - litem abbreviation stands for LINE ITEM
const Litem = (props) => {
  const { MinicartClass, index, properties } = props
  const embroideryText = properties?.['Embroidery Text'] ?? '';
  const embroideryStyle = properties?.['Embroidery Style'] ?? '';
  const cartCount = MinicartClass.state.cartCount;
  
  const getExtraData = () => {
    // get extra info from product alt template (see product.json.liquid)
    axios.get(`${(props.url).split('?')[0]}?view=json`)
      .then(({ data }) => {
        const filteredData = data.variants.filter(variant => variant?.id === props?.id)
        setExtraVariantData(filteredData[0])
      })
  }

  const checkVariantRecos = () => {
    // check if last litem and set the variant recos to the current metafield recommendations
    const varRecos = extraVariantData?.metafields?.r_variants
    if (cartCount === 1 && varRecos !== undefined) {
      if (varRecos.length > 0) {
        props.setVariantRecos(varRecos)

        if (isEmbroidery && litemProperties !== null) {
          props.setCurrentEmbProperties(litemProperties)
        } else {
          props.setCurrentEmbProperties(null)
        }
      } else {
        props.setVariantRecos(null)
      }
    }
  }

  const checkIfEmbroidery = () => {
    if (properties && embroideryText || embroideryStyle) setIsEmbroidery(true)
  }

  const [litemProperties, setLitemProperties] = useState(properties)
  const [isEmbroidery, setIsEmbroidery] = useState(false)
  const [extraVariantData, setExtraVariantData] = useState(null)
  const [inventoryState, setInventoryState] = useState(null)
  const inventoryStateMessage = extraVariantData?.metafields?.variant_state_message
  const [loading, setLoading] = useState(false)
  const [qty, setQty] = useState(props.quantity)
  const [isCheckingBackorder, setIsCheckingBackorder] = useState(properties && properties.Status === "Backordered");

  useEffect(() => {
    setQty(props.quantity)
    checkIfEmbroidery()
    getExtraData()
  }, [props.quantity, cartCount])

  useEffect(() => {
    updateInventoryProperty()
  }, [inventoryState])

  useEffect(() => {
    checkInventoryState()
    checkVariantRecos()
  }, [extraVariantData])

  let litemMessageEmb = ''
  if (isEmbroidery) litemMessageEmb = 'As they’re made to order, personalized items cannot be exchanged or returned.'

  let litemMessageBackorder = ''
  if (inventoryState !== null && inventoryState === 'backorder') {
    litemMessageBackorder = (inventoryStateMessage !== null) ? `${inventoryStateMessage} ` : 'Backordered: Ships when back in stock.'
  }

  const litemMessage = `${litemMessageBackorder}`

  const checkInventoryState = () => {
    // if inventory is below 0 and set to "continue to order"
    if (
      extraVariantData?.available &&
      extraVariantData?.inventory_quantity <= 0 &&
      !props.product_title.toLowerCase().includes('gift card')
    ) {
      setInventoryState('backorder');
    }
  }

  const changeLitem = (data) => {
    setLoading(true)
    axios.post('/cart/change.js', data)
      .then(() => {
        if (data.properties) { 
          setLitemProperties(data.properties)
        }
        setQty(data.quantity)
        MinicartClass.getCartData()
        setLoading(false)
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 422) updateItem(0)
          alert(error.response.data.description)
        }
        setLoading(false)
      })
  }

  const updateInventoryProperty = () => {
    let data = { line: index, quantity: qty }
    if (inventoryState === 'backorder' && !isCheckingBackorder) {
      if (litemMessage !== null) {
        data.properties = { ...litemProperties, Status: 'Backordered', Backorder: litemMessage };
      } else {
        data.properties = { ...litemProperties, Status: 'Backordered' };
      }
      changeLitem(data);
    }
  };

  const updateItem = (quantity = 1) => {
    let data = { line: index, quantity ,currency:getCurrency()}

    changeLitem(data)
  }

  const plus = () => {
    updateItem(qty + 1)
    var dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'add_to_cart_track',
      ecommerce: {
        currency:getCurrency(),
        value: parseInt(util.formatMoney(props.price).replace('$', '').replace(',', '').replace(/'/g, '')),
        items: [{
          item_list_id: `${props.product_id}`, //TODO: ADD PRODUCT ID VS VARIANT ID
          item_list_name: `${props.product_title}`,
          item_id: `${props.variant_id}`,
          item_name: `${props.product_title}`,
          affiliation: 'Weezie Towels',
          currency:getCurrency,
          coupon: null,
          discount: extraVariantData?.compare_at_price ? util.formatMoney(extraVariantData?.compare_at_price, '${{amount}}').replace('$', '').replace(',', '') - util.formatMoney(props?.price, '${{amount}}').replace('$', '').replace(',', '') : 0,
          index: 0,
          item_brand: 'Weezie Towels',
          item_category: `${props.product_type}`,
          item_category2: `${props.options_with_values[0].value}`,
          item_category3: null,
          item_category4: null,
          item_variant: null,
          price: parseInt(util.formatMoney(props.price).replace('$', '').replace(',', '')),
          quantity: 1
        }]
      }
    })
    
  }

  const minus = () => {
    updateItem(qty - 1)

    var dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: getCurrency(),
        value: parseInt(util.formatMoney(props.price).replace('$', '').replace(',', '').replace(/'/g, '')),
        items: [{
          item_list_id: `${props.product_id}`,
          item_list_name: `${props.product_title}`,
          item_id: `${props.variant_id}`,
          item_name: `${props.product_title}`,
          affiliation: 'Weezie Towels',
          currency: getCurrency(),
          coupon: null,
          discount: extraVariantData?.compare_at_price ? util.formatMoney(extraVariantData?.compare_at_price, '${{amount}}').replace('$', '').replace(',', '') - util.formatMoney(props?.price, '${{amount}}').replace('$', '').replace(',', '') : 0,
          index: 0,
          item_brand: 'Weezie Towels',
          item_category: `${props.product_type}`,
          item_category2: `${props.options_with_values[0].value}`,
          item_category3: null,
          item_category4: null,
          item_variant: null,
          price: parseInt(util.formatMoney(props.price).replace('$', '').replace(',', '')),
          quantity: 1
        }]
      }
    })
  }

  const remove = () => {
    updateItem(0)

    var dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: getCurrency(),
        value: parseInt(util.formatMoney(props.price).replace('$', '').replace(',', '').replace(/'/g, '')),
        items: [{
          item_list_id: `${props.product_id}`,
          item_list_name: `${props.product_title}`,
          item_id: `${props.variant_id}`,
          item_name: `${props.product_title}`,
          affiliation: 'Weezie Towels',
          currency: getCurrency(),
          coupon: null,
          discount: extraVariantData?.compare_at_price ? util.formatMoney(extraVariantData?.compare_at_price, '${{amount}}').replace('$', '').replace(',', '') - util.formatMoney(props?.price, '${{amount}}').replace('$', '').replace(',', '') : 0,
          index: 0,
          item_brand: 'Weezie Towels',
          item_category: `${props.product_type}`,
          item_category2: `${props.options_with_values[0].value}`,
          item_category3: null,
          item_category4: null,
          item_variant: null,
          price: parseInt(util.formatMoney(props.price).replace('$', '').replace(',', ''))
        }]
      }
    })
  }

  const keyPressQuantity = (event, plus, minus) => {
    if (event.charCode == 13) {
      if (plus) {
        updateItem(qty + 1)
      }

      if (minus) {
        updateItem(qty - 1)
      }
    }
  }

  // set embroidery params if they exist
  let pdpUrl = props.url
  if (isEmbroidery && litemProperties !== null) {
    const url = new URL(`${location.origin}${props.url.split('?')[0]}`)
    url.searchParams.set('embvariant', props.id)

    Object.entries(litemProperties).map(([key, value]) => {
      if ( key === 'Embroidery Text') url.searchParams.set('personalized', value)
      if ( key === 'Embroidery Style') url.searchParams.set('font', value)
      if ( key === 'Embroidery Color') url.searchParams.set('color', value)
    })

    pdpUrl = `${url}`
  }

  return (
    <div className="litem">
      <div className="litem__container">
        <a className="litem__img" href={pdpUrl}>
          <img src={props.image} alt="{props.product_title}" />
          {(isEmbroidery && props.product_title !== 'Gift Wrap' && !props?.tags?.includes("faux emb") ) && <EmbPreview properties={litemProperties} />}
        </a>

        <div className="litem__inner">
          <div className="litem__header">
            <p className="litem__title"><a href={pdpUrl}>{props.product_title}</a></p>
            <div className="litem__price">
              {extraVariantData?.compare_at_price && extraVariantData?.compare_at_price > props?.price ?
                <>
                  <s>{util.formatMoney(extraVariantData?.compare_at_price * qty, '${{amount}}').replace('.00', '')}</s>
                  <span>{util.formatMoney(props?.original_line_price, '${{amount}}').replace('.00', '')}{visitorCountry === 'CA' && ' CAD'}</span>
                </>
              :
                <span>
                  {props.product_title !== 'Gift Wrap' ?
                  <>
                  {util.formatMoney(props?.original_line_price, '${{amount}}').replace('.00', '')}{visitorCountry === 'CA' && ' CAD'}
                  </>
                  :
                  <>
                  {util.formatMoney(props.price, '${{amount}}').replace('.00', '')}{visitorCountry === 'CA' && ' CAD'}
                  </>}
                </span>
              }
            </div>
          </div>

          <div className="litem__properties">
            {props.options_with_values.map((option, i) => {
              const optionName = option.name.toLowerCase()
              if (!optionName.includes('embroidery') && !optionName.includes('title') && !optionName.includes('gift card')) {
                return <p className="litem__property-option" key={`${option.value}-${i}`}><span>{option.name}</span>&nbsp;{option.value}</p>
              }
            })}

            {props.product_title.toLowerCase().includes('physical gift card') && (
              <p className="litem__property-option" key={`gc-toggle`} style={{ cursor: 'pointer' }} onClick={() => props.showGiftMessage()}>{!props.hasGiftMessage ? '+ Add a note' : '- Edit note'}</p>
            )}

            {/* for testing properties */}
            {/* {(litemProperties !== null) && Object.entries(litemProperties).map(([key, value]) => <p className="litem__property-option litem__property-option--lesspad" style={{ color: '#ff2626d1' }} key={key}>[[{key}]]: {value}</p>)} */}
            {(isEmbroidery && props.product_title !== 'Gift Wrap' && litemProperties !== null) && <div className="litem__embprops">
              {Object.entries(litemProperties).map(([key, value]) => (
                value !== '' && value !== 'Icon' && (
                  <p className="litem__property-option litem__property-option--lesspad" key={key}>
                    { key === 'Embroidery Text' ? <><span>Personalized</span> “{value}”;</> : '' }
                    { key === 'Embroidery Style' ? <><span>Font</span> {value};</> : '' }
                    { key === 'Embroidery Color' ? <><span>Color</span> {value};</> : '' }
                  </p>
                )
              ))}
            </div>}
          </div>
          
          {props.product_title !== 'Gift Wrap' 
          ?
            <div className="litem__actions_wrap">
            <div className="litem__qty">
              <div className="litem__qty-btn litem__qty-btn--minus" tabIndex="0" onKeyPress={(event) => keyPressQuantity(event, false, true)} onClick={minus}>-</div>
              <span className="litem__qty-count">{qty}</span>
              <div className="litem__qty-btn litem__qty-btn--plus" tabIndex="0" onKeyPress={(event) => keyPressQuantity(event, true, false)} onClick={plus}>+</div>
              <div className={`litem__loader${loading ? ' litem__loader--loading' : ''}`}></div>
            </div>
            <button className="remove-item_cs" onClick={remove}>
              <svg width="15" height="15" viewBox="0 0 28 28" fill="none">
                <line x1="5.42426" y1="4.57574" x2="23.4243" y2="22.5757" stroke="#14334C" stroke-width="1.2"/>
                <line x1="4.57574" y1="22.5757" x2="22.5757" y2="4.57574" stroke="#14334C" stroke-width="1.2"/>
                <line x1="4.57574" y1="22.5757" x2="22.5757" y2="4.57574" stroke="#14334C" stroke-width="1.2"/>
              </svg>
            </button>
            </div>
          :
            <button className="litem__remove btn btn--text btn--x-small" onClick={remove}>Remove</button>
          }
        </div>
      </div>

      {(litemMessage !== '' && props.product_title !== 'Gift Wrap') && <p className="litem__message">{litemMessage}</p>}
    </div>
  )
}

export default Litem
